<template>
  <div class="activities-block activities">
    <preloader :visible="preloader" />
    <alert-message :message="message" />
    <v-server-table ref="vuetable" :url="route" :columns="columns" :options="options" @loading="onLoading" @loaded="onLoaded"  class="custom-table-modifier">
      <template v-slot:created_at="r">
        <div class="min-width nobr">{{ r.row.created_at }}</div>
      </template>
      <template v-slot:user="r">
        <div class="nobr" v-if="r.row.user"><a :href="'/user/' + r.row.user.id" v-html="r.row.user.name"></a></div>
      </template>
      <template v-slot:type="r">
        <div class="nobr">
          <a :href="r.row.action.type + '/' + r.row.action.type_id">{{ r.row.action.type + ' #' + r.row.action.type_id }}</a>
        </div>
      </template>
      <template v-slot:description="r">
        <div v-html="r.row.action.description"></div>
      </template>
    </v-server-table>
  </div>
</template>

<script>
import Preloader from "./blocks/preloader";
import AlertMessage from "./blocks/alert-message";

export default {
  components: { AlertMessage, Preloader },
  props: {
    route: {
      type: String
    },
    dateFormat: {
      type: String,
      default: 'MM-DD-YYYY'
    }
  },
  data() {
    return {
      message: '',
      preloader: false,
      columns: [ 'created_at', 'user', 'type', 'description' ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        requestFunction: (data) => {
          return axios.get(this.route, { params: data });
        },
        dateColumns: [ 'created_at' ],
        dateFormat: this.dateFormat,
        datepickerOptions: {
          showDropdowns: true,
          autoUpdateInput: true
        },
        orderBy: {
          ascending: false
        },
        perPage: 30,
        pagination: {
          chunk: 30,
          dropdown: false
        },
        filterable: [ 'created_at', 'user', 'type', 'description' ],
        sortable: [],
        headings: {
          created_at: 'Date',
          user: 'User',
          type: 'Object',
          description: 'Details',
        }
      }
    }
  },
  methods: {
    momentVue(...args) {
      return moment(...args).utc();
    },
    momentDiff(timestamp) {
      return moment().diff(moment.utc(timestamp), 'minutes');
    },
    momentFromNow(timestamp) {
      return moment.utc(timestamp).fromNow();
    },
    onLoading(e) {
      this.preloader = true;
    },
    onLoaded(e) {
      this.preloader = false;
    },
  },
}
</script>
